import { render, staticRenderFns } from "./IndexBlogType.vue?vue&type=template&id=3c5e79e4&"
import script from "./IndexBlogType.vue?vue&type=script&lang=js&"
export * from "./IndexBlogType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports